import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  transactionData: {},
  transactionInsertedData: {},
  transactionByTransactionIdData: {},
  loading: false,
  error: null,
};

export const transactionSlice = createSlice({
  name: "transaction",
  initialState,
  reducers: {
    transactionSuccess: (state, action) => {
      state.transactionData = action.payload;
      state.loading = false;
      state.error = null;
    },
    transactionReset: (state) => {
      state.transactionData = {};
      state.loading = false;
      state.error = null;
    },
    transactionLoading: (state) => {
      state.loading = true;
      state.error = null;
    },
    transactionError: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    transactionInsertSuccess: (state, action) => {
      state.transactionInsertedData = action.payload;
      state.loading = false;
      state.error = null;
    },
    transactionInsertReset: (state) => {
      state.transactionInsertedData = {};
      state.loading = false;
      state.error = null;
    },
    transactionByTransactionIdSuccess: (state, action) => {
      state.transactionByTransactionIdData = action.payload;
      state.loading = false;
      state.error = null;
    },
  },
});

export const {
  transactionReset,
  transactionSuccess,
  transactionLoading,
  transactionError,
  transactionInsertSuccess,
  transactionInsertReset,
  transactionByTransactionIdSuccess,
} = transactionSlice.actions;

export default transactionSlice.reducer;
